// Lib
import { useSelector } from 'react-redux';

const useFeature = (feature) =>
  useSelector((state) => state?.user?.features?.[feature] ?? false);

export default useFeature;
